export default __webpack_public_path__ + "assets/icons/support_curve.90e8a5a3.svg";